import { Grid, GridProps } from '@mui/material';

export default Grid;
export type { GridProps };
